import store from "@/store";
import { notifyAlert } from "@/helpers/helper";

export default async function auth(to, from, next) {

  const isAuthenticated = store.getters["auth/isAuthenticated"];
  const user =  store.getters["auth/currentUser"];
  const isTokenValid = store.getters["auth/isTokenValid"];

  if (
      !user ||
      !isAuthenticated ||
      !isTokenValid
  ) {
    notifyAlert("", "Necessário se autenticar novamente.");
    await store.dispatch("auth/logout");
    return next({ name: "login" });
  }

  const allowedRoles = to.meta.roles;
  const userRole = user?.tipoUsuario;

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    notifyAlert("", "Acesso não autorizado.");
    return next({ name: "nao-autorizado" });
  }

  return next();
}
